export const version = 'v2.2.4-2073-g82a241599'
